import { isSupportedSellerLanguage } from '../supportedSellerLanguages';
import { getShortLanguageCode } from '../shortLanguageCode';
import { BLOCKED_COUNTRIES_SET, MINIMUM_VALIDATED_LANGUAGE_LEVEL } from './constants';

/**
 * Get a subset of the seller proficient languages according to the following business logic rules:
 * - Do not rely on sellers input if sellers are coming from some countries
 * - Return only languages with level higher than Basic (1)
 * We are making sure we return list of unique language codes.
 * if in the input we get more than one language, we take the one with the higher proficiency level.
 * @param proficientLanguages {Array} - Array of objects: {name, level}, for example: [{name: 'en', level: 4}]
 * @param countryCode {string} - represents the seller country, for example: 'US'
 * @returns {Array} - Array of language objects, sorted by its level
 */
export const getSellerValidatedLanguages = ({ proficientLanguages = [], countryCode = '' } = {}) => {
    if (BLOCKED_COUNTRIES_SET.has(countryCode)) {
        return [];
    }

    const sellerValidatedLanguagesMap = {};
    proficientLanguages.forEach((proficientLanguageObj) => {
        const proficientLanguageLevel = proficientLanguageObj.level;
        const proficientLanguageCode = getShortLanguageCode(proficientLanguageObj.name);
        if (proficientLanguageLevel >= MINIMUM_VALIDATED_LANGUAGE_LEVEL && isSupportedSellerLanguage(proficientLanguageCode)) {
            const validatedLanguageLevel = sellerValidatedLanguagesMap[proficientLanguageCode];
            if (!validatedLanguageLevel || validatedLanguageLevel < proficientLanguageLevel) {
                sellerValidatedLanguagesMap[proficientLanguageCode] = proficientLanguageLevel;
            }
        }
    });

    return Object.keys(sellerValidatedLanguagesMap).map((key) => ({
        name: key,
        level: sellerValidatedLanguagesMap[key]
    })).sort((a, b) => (a.level > b.level) ? -1 : 1);
};
